import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Navbar expand="lg" style={{ backgroundColor: "#A7C1A8" }} variant="dark" fixed="top">
      <Container>
        <Navbar.Brand href="/user-dashboard">User Panel</Navbar.Brand>
        <Navbar.Toggle aria-controls="user-navbar" />
        <Navbar.Collapse id="user-navbar">
          <Nav className="me-auto">
            <Nav.Link href="/user-home">Home</Nav.Link>
            <Nav.Link href="/profile">Profile</Nav.Link>
            <Nav.Link href="/orders">My Orders</Nav.Link>
          </Nav>
          <Button variant="light" onClick={handleLogout}>Logout</Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default UserNavbar;
